import Flex from '@ilg-totallymoney/ui/components/Flex'
import theme from '@ilg-totallymoney/ui/theme'

const Trustpilot = () => (
    <Flex
        className="trustpilot-widget"
        id="Trustpilot-carousel"
        data-locale="en-GB"
        data-template-id="53aa8807dec7e10d38f59f32"
        data-businessunit-id="4ecbc5d70000640005119c22"
        data-style-align="center"
        data-style-width="50%"
        data-theme="light"
        data-stars="4,5"
        data-text-color={theme.grey100}
        data-schema-type="Organization"
        justifyContent="center"
        alignItems="center"
        width="100%"
        m="0 auto"
    >
        <a
            href="https://uk.trustpilot.com/review/www.totallymoney.com"
            target="_blank"
            rel="noopener noreferrer"
        />
    </Flex>
)

export default Trustpilot
